export default __webpack_public_path__ + "static/media/avatar_126.a5833e4c.png";